import Button from 'components/Button'

import { ButtonContainer } from './styles'

export const ButtonsContainer = ButtonContainer

export default Button
